import { AppFeatureService } from "@sleek-sdk/sleek-cms";
import { getAppCustomEnv } from "@sleek/customer-common-acquisition";

import { memoizedCountryCodeFromDomain } from "@/utils/get-country-code-from-domain";
import pMemoize from "p-memoize";

const getSettings = async () => {
  const appCustomEnv = await getAppCustomEnv();

  return {
    remote_base_url: appCustomEnv.VUE_APP_CMS_CONTENT_REMOTE_URL,
    environment: appCustomEnv.VUE_APP_CMS_CONTENT_ENVIRONMENT,
    country_code: appCustomEnv.VUE_APP_CMS_CONTENT_COUNTRY_CODE,
    debug: true,
  };
};

export const getPlatformConfig = async () => {
  const settings = await getSettings();
  // AppFeatureService.override(OverrideAppFeatures);
  const appFeatureService = new AppFeatureService({
    settings: settings,
    options: {
      returnNullIfNotFound: false,
    },
  });
  const backendConfig = {};
  const [countryCode, cmsAppFeatures, cmsGeneralFeatureList] =
    await Promise.all([
      memoizedCountryCodeFromDomain(),
      appFeatureService.getCustomerFeatureList(),
      appFeatureService.getGeneralFeatureList(),
    ]);
  backendConfig.cmsAppFeatures = cmsAppFeatures;
  backendConfig.cmsGeneralFeatureList = cmsGeneralFeatureList;
  backendConfig.tenant = countryCode.slice(0, 2).toLowerCase();
  backendConfig.domain_url = location.hostname;
  backendConfig.country_code = countryCode; // Similar to getTenantId
  return backendConfig;
};

export default pMemoize(getPlatformConfig);
